module.exports = __webpack_public_path__ + "assets/images/icons/logo.d920633092f09fa25abc1a3160ad8df6.svg";